import React from 'react';
import { ListItem, ListItemAvatar, Avatar, ListItemText, Divider } from '@material-ui/core';
import { Reais } from '../../components/numberUtils';
import { VendaForma } from '../../models/venda';

export const ListItemFormaPgto = (props: VendaForma) => {

  return <div key={props.formaNome}>
    <ListItem>
      <ListItemAvatar>
        <Avatar variant="rounded" style={{ backgroundColor: 'orange' }}>
          {props.formaNome}
        </Avatar>
      </ListItemAvatar>
      <ListItemText secondary={<span>{props.formaNome} </span>}>
        {props.contagem} venda(s)
      </ListItemText>
      <ListItemText style={{ textAlign: 'right' }}>
        <b style={{ fontSize: '1.1rem' }}><Reais valor={props.total} />  </b>
      </ListItemText>
    </ListItem>
    <Divider />
  </div>;
};
